import { Component, Input, OnInit } from '@angular/core';
import { AccessPoint } from '../../model/access-point.model';
import { Authorization } from '../../model/authorization';
import { AuthRoles_PTBR } from '../../model/AuthRoles';
import { User } from '../../model/user';
import { UserService } from '../../service/user.service';
import { PopupImageComponent } from '../popup-image/popup-image.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Essentials } from '../../util/essentials';

@Component({
  selector: 'user-card-slim',
  templateUrl: './user-card-slim.component.html',
  styleUrls: ['./user-card-slim.component.css']
})
export class UserCardSlimComponent implements OnInit {
  public defaultPictureAvatar: string;
  constructor(private modalservice: BsModalService,  private essentials: Essentials,) {
    this.defaultPictureAvatar =  essentials.getDefaultAvatar();
  }

  modalRef: BsModalRef;

  @Input() access: {
    accessPoint: string,
    accessDirectionAsString: string,
    moment: string,
    userDoc: string,
    userName: string,
    photoB64: string,
    photo: string,
    similarity: number,
    faceMask: string,
    rfId: string,
    qrCode: string,
    blocked: boolean,
    role: string
  };

  ngOnInit(): void {
    // formata a data-hora para ficar mais legivel
    this.access.moment = `${this.access.moment.substr(8,2)}/${this.access.moment.substr(5,2)} - ${this.access.moment.substr(11,8)}`
  }

  showImage() {
    if ((this.access.rfId == "" || this.access.rfId == null) && (this.access.qrCode == "" || this.access.qrCode == null)) {
      this.modalRef = this.modalservice.show(PopupImageComponent, Object.assign({}, { class: 'gray modal-md modal-dialog-centered' }));
      this.modalRef.content.photo = this.access.photoB64;
      this.modalRef.content.hasPhoto2 = this.access.photo != undefined && this.access.photo != null;
      this.modalRef.content.photo2 = this.access.photo;
      this.modalRef.content.userName = this.access.userName;
      this.modalRef.content.accessPoint = this.access.accessPoint;
      this.modalRef.content.accessDirectionAsString = this.access.accessDirectionAsString;
      this.modalRef.content.moment = this.access.moment;
      this.modalRef.content.similarity = this.access.similarity;
      this.modalRef.content.faceMask = this.access.faceMask;
      this.modalRef.content.rfId = this.access.rfId;      
    }
  }

  getTranslationKey(direction: string): string {
    return `REPORT_RECENT_ACCESS.RECENT_ACCESS.PAGE.USER_CARD_SLIM.${direction}`;
  }

}
